// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"brightness"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M4.57537 8.92462L1.5 12L4.57537 15.0754V19.4246H8.92462L12 22.5L15.0754 19.4246H19.4246V15.0754L22.5 12L19.4246 8.92462V4.57538H15.0754L12 1.5L8.92462 4.57538H4.57537V8.92462Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","cx":12,"cy":12,"r":5,"fill":"transparent"},"nodeName":"circle","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4.57537 8.92462L1.5 12L4.57537 15.0754V19.4246H8.92462L12 22.5L15.0754 19.4246H19.4246V15.0754L22.5 12L19.4246 8.92462V4.57538H15.0754L12 1.5L8.92462 4.57538H4.57537V8.92462Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","cx":12,"cy":12,"r":5,"stroke":"currentColor","stroke-width":2},"nodeName":"circle","children":[]}]}]};

@tag('t-icon-brightness')
export default class BrightnessIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'brightness',
    }
  }
}
